import LegalPageLayout from '../components/LegalPageLayout';

const guidelines = [
  'Wear workout clothes and closed-toe shoes.',
  'Shirts and tops must be worn at all times.',
  'Put equipment back where you found it.',
  'Do not move equipment into different rooms.',
  'Re-rack your weights.',
  'Allow others to work in with you.',
  'Use headphones instead of playing loud music.',
  'Leave gym bags in lockers.',
  'Limit cardio equipment use to 30 minutes when others are waiting.',
  'Do not use phones or cameras to photograph or record other people without their explicit consent.',
];

const FacilityGuidelinesPage = () => (
  <LegalPageLayout title="Facility Guidelines & Policies" description="Delta Valley Health Club facility rules and member guidelines.">
    <p className="dv-size-body">Help us keep Delta Valley safe, welcoming, and enjoyable for every member and guest.</p>
    <ul>{guidelines.map((guideline) => <li className="dv-size-body" key={guideline}>{guideline}</li>)}</ul>
    <p className="dv-size-body">Questions about a policy? Call <a href="tel:9252402990">(925) 240-2990</a> or speak with a team member at the front desk.</p>
  </LegalPageLayout>
);

export default FacilityGuidelinesPage;
